<template>
  <div>
    <conditions-for-participation />
    <privacy />
  </div>
</template>

<script>
import ConditionsForParticipation from '@/components/ConditionsForParticipation.vue'
import Privacy from '@/components/Privacy.vue'
export default {
  components: { ConditionsForParticipation, Privacy },
}
</script>

<style></style>
